import { render, staticRenderFns } from "./MirrorsTab.vue?vue&type=template&id=e6d47010&scoped=true&"
import script from "./MirrorsTab.vue?vue&type=script&lang=js&"
export * from "./MirrorsTab.vue?vue&type=script&lang=js&"
import style0 from "./MirrorsTab.vue?vue&type=style&index=0&id=e6d47010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d47010",
  null
  
)

export default component.exports